<template>
  <UPageSection
    v-if="members.length"
    :dir="dir"
    :title="title"
    :ui="{
      title: 'text-2xl font-bold sm:text-3xl text-center',
      container: 'py-10 sm:py-14',
    }"
  >
    <div class="grid items-stretch gap-5 sm:grid-cols-2 lg:grid-cols-3">
      <UPageCard
        v-for="(member, index) in members"
        :key="index"
        variant="subtle"
        class="h-full"
        :ui="{ container: 'gap-3 items-center text-center' }"
      >
        <div class="flex flex-col items-center gap-3">
          <UAvatar
            v-if="member.image"
            :src="member.image"
            :alt="member.name || 'Team member'"
            class="size-20"
          />
          <UAvatar
            v-else
            :alt="member.name || 'Team member'"
            icon="i-lucide-user"
            class="size-20"
          />
          <div class="min-w-0 space-y-1">
            <h3 class="line-clamp-2 min-h-14 text-lg font-semibold leading-7 text-highlighted">
              {{ member.name }}
            </h3>
            <p class="line-clamp-1 min-h-5 text-sm font-medium leading-5 text-primary">
              {{ member.role }}
            </p>
            <p class="line-clamp-3 min-h-[4.5rem] text-sm leading-6 text-muted">
              {{ member.bio }}
            </p>
          </div>
        </div>
      </UPageCard>
    </div>
  </UPageSection>
  <UPageSection
    v-else
    :dir="dir"
    :title="title"
    :ui="{
      title: 'text-2xl font-bold sm:text-3xl text-center',
      container: 'py-10 sm:py-14',
    }"
  >
    <p class="text-center text-sm text-muted">
      هنوز عضوی به تیم اضافه نشده است.
    </p>
  </UPageSection>
</template>

<script setup lang="ts">
export type TeamMember = {
  name?: string
  role?: string
  image?: string
  bio?: string
}

withDefaults(
  defineProps<{
    title?: string
    members?: TeamMember[]
  }>(),
  {
    members: () => [],
  },
)

const dir = useDir()
</script>
